function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#SocialTwitch_svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.496 9.187l-2.763 2.753H9.971l-2.417 2.409v-2.41H4.446V1.616h11.05v7.572z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.755.239L.302 3.68v12.39h4.143v3.442L7.9 16.07h2.762l6.216-6.195V.24H3.755zm11.74 8.948l-2.762 2.753H9.97l-2.417 2.41v-2.41H4.445V1.615h11.05v7.572z",
  fill: "#9146FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.424 4.024h-1.381v4.13h1.381v-4.13z",
  fill: "#9146FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.626 4.024H8.245v4.13h1.38v-4.13z",
  fill: "#9146FF"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "SocialTwitch_svg__clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16.575,
  height: 19.273,
  fill: "#fff",
  transform: "translate(.302 .239)"
})));

function SvgSocialTwitch(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

SvgSocialTwitch.defaultProps = {
  color: "#000",
  title: "Social Twitch"
};
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJyZWFjdC1jb21wb25lbnRzL2ljb25zL1NvY2lhbFR3aXRjaC0wY2M3YzBiZjU2NDgxZTVjODY1M2M3OGI5OWZiMjU4Ny5zdmciOw==";
export { SvgSocialTwitch as ReactComponent };